import React, { useState, useEffect, useRef, createContext } from "react";

export const EditorContext = createContext();

export const EditorState = ({ children }) => {
  // Close modals by clicking anywhere
  const settingsRef = useRef(null);
  const viewRef = useRef(null);
  // Get output/iframe
  const outputRef = useRef(0);

  // Toggle menu for mobile
  const [hiddenMenu, setHiddenMenu] = useState(true);

  // Editor settings
  const [html, setHtml] = useState("");
  const [url, setUrl] = useState("about:blank");
  const [css, setCss] = useState("");

  // Button settings
  const [activeView, setActiveView] = useState("Editor View");
  const [isOpened, setIsOpened] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [isSettings, setIsSettings] = useState(false);
  const [layout, setLayout] = useState("Left");

  // Input settings
  const [title, setTitle] = useState("Project Title");
  const [name, setName] = useState("Publisher");

  // Set width of the iframe/output on page resize
  const [outputWidth, setOutputWidth] = useState("");
  let timeoutId;
  const resizeOutput = () => {
    setOutputWidth(outputRef.current.offsetWidth);
  };

  // Run the resize function, and clear it after 1 second if you are not resizing
  window.addEventListener("resize", () => {
    resizeOutput();
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      setOutputWidth("");
    }, 1000);
  });

  useEffect(() => {
    // Show code on page
    const htmlObj = URL.createObjectURL(
      new Blob([`<style>${css}</style>`, html], { type: "text/html" })
    );
    setUrl(htmlObj);
    return () => URL.revokeObjectURL(htmlObj);
  }, [html, css]);

  const handleSave = () => {
    // Save editor settings, html and css
    localStorage.setItem("Html", html);
    localStorage.setItem("Css", css);
    setIsSaved(true);
  };

  const handleSettings = () => {
    // Save title, name, and layout
    localStorage.setItem("Title", title);
    localStorage.setItem("Name", name);
    localStorage.setItem("Layout", layout);
    setIsSettings(false);
  };

  const handleNewPen = () => {
    // Clear everything
    localStorage.setItem("Html", "");
    localStorage.setItem("Css", "");
    localStorage.setItem("Title", "Project Title");
    localStorage.setItem("Name", "Publisher");
    setHtml("");
    setCss("");
    setTitle("Project Title");
    setName("Publisher");
  };

  useEffect(() => {
    // Timeout for saved button
    const timeoutId = setTimeout(() => {
      setIsSaved(false);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, [isSaved]);

  useEffect(() => {
    // Get editor settings
    if (localStorage.getItem("Html") !== null) {
      const codeHtml = localStorage.getItem("Html");
      setHtml(codeHtml);
    }
    if (localStorage.getItem("Css") !== null) {
      const codeCss = localStorage.getItem("Css");
      setCss(codeCss);
    }
    // Get title and name
    if (localStorage.getItem("Title") !== null) {
      const projectTitle = localStorage.getItem("Title");
      setTitle(projectTitle);
    }
    if (localStorage.getItem("Name") !== null) {
      const userName = localStorage.getItem("Name");
      setName(userName);
    }
    // Get layout
    if (localStorage.getItem("Layout") !== null) {
      const codeLayout = localStorage.getItem("Layout");
      setLayout(codeLayout);
    }
  }, []);

  // Set title of the page
  document.title = title;

  return (
    <EditorContext.Provider
      value={{
        html,
        setHtml,
        url,
        setUrl,
        css,
        setCss,
        activeView,
        setActiveView,
        isOpened,
        setIsOpened,
        isSaved,
        setIsSaved,
        isSettings,
        setIsSettings,
        handleSave,
        settingsRef,
        viewRef,
        handleSettings,
        title,
        setTitle,
        name,
        setName,
        handleNewPen,
        layout,
        setLayout,
        outputWidth,
        outputRef,
        hiddenMenu,
        setHiddenMenu,
      }}
    >
      {children}
    </EditorContext.Provider>
  );
};
